import React from 'react';
import { ZdsDivider, ZdsIcon, ZdsItem } from '@zig-design-system/ui-components-react';
const DownloadResult = ({ hit }) => {
    const getSummary = (hit) => {
        var _a;
        const content = (_a = hit.highlight['data.hiddenContent']) !== null && _a !== void 0 ? _a : null;
        if (content) {
            if (content[0].endsWith('>')) {
                return '...' + content[0].slice(-150) + '...';
            }
            return content[0];
        }
        return hit._source.content;
    };
    const formatSize = (bytes, decimals = 2, compactSmallNumbers = true) => {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024, sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], i = Math.floor(Math.log(bytes) / Math.log(k));
        return (Number((bytes / Math.pow(k, i)).toFixed(compactSmallNumbers && i < 2 ? 0 : decimals)).toLocaleString(window.document.documentElement.lang) +
            ' ' +
            sizes[i]);
    };
    return (React.createElement("div", null,
        React.createElement(ZdsItem, { link: hit._source.url, linkTarget: "_blank" },
            React.createElement("div", { slot: "label-text" },
                hit._source.fields.mimeType === 'application/pdf' && (React.createElement(ZdsIcon, { library: "fa-solid", name: "file-pdf", size: "sm" })),
                "\u00A0",
                formatSize(hit._source.fields.size)),
            React.createElement("div", { slot: "primary-text", className: "zds-bold zds-truncate zds-margin-top-2" }, hit._source.title),
            React.createElement("div", { slot: "secondary-text", className: "zds-truncate", dangerouslySetInnerHTML: { __html: hit._source.fields.description || getSummary(hit) } }),
            React.createElement("div", { slot: "content-end" }, hit._source.fields.mimeType === 'application/pdf' ? (React.createElement(ZdsIcon, { library: "fa-solid", name: "arrow-up-right-from-square", size: "sm" })) : (React.createElement(ZdsIcon, { library: "fa-solid", name: "download", size: "sm" })))),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
export default DownloadResult;
